export default __webpack_public_path__ + "static/media/T09E.83ab03c6.png";